<template>
  <div class="paymentwaiting">
    <div class="pay91_Page payTm">
      <div class="payTm_Header">
        <span>Payment Status</span>
      </div>
      <div class="payTmContent">
        <img src="../../assets/images/uploadUserImage.png" class="imgResponsive"  alt="user-image" />
        <div class="congratsText">
          <div class="giftStep">
            <img src="../../assets/images/waitingIcon.gif" class="payTmIcon" alt="waiting-icon" />
            <span class="waiting">कृपया प्रतीक्षा करें ...</span>
            <span class="paytm">आपका भुगतान लिया जा रहा है ...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../store/store';

export default {
  name: "Payment_Waiting",
  data() {
    return {
      polling: {},
      intervalId: 0,
      intervalCount: 0,
      intervalCountTime: 36
    };
  },
  methods: {
    status() {
      if (this.intervalCount >= this.intervalCountTime) {
        clearInterval(this.intervalId);
      } else {
        this.intervalId = setInterval(() => {
          if (this.intervalCount >= this.intervalCountTime) {
            clearInterval(this.intervalId);
          }
          this.intervalCount++;
          this.$store.dispatch({
              type:'orderById',
              payload: this.$route.params.orderId
          })
            .then(data => {
              this.polling = data.data;
              if (data.data.orderState != null) {
                if (data.data.orderState == "PAYMENT_PENDING") {
                } else if (["PAYMENT_FAILURE", "CONFIRMED"].includes(data.data.orderState)) {
                  clearInterval(this.intervalId);
                  this.$router.onError(err => {
                  if (/loading chunk \d* failed./i.test(err.message)) {
                    window.location.reload()
                  }
                });
                  this.$router.push('/orderDetails/' + this.$route.params.orderId)
                }
              } else {
                this.transactionMessage =
                  "किसी कारणवश मर्चेंट को पेटीएम में पेमेंट देने में देरी होने की वजह से आपका भुगतान आपको रिफंड कर दिया गया";
                clearInterval(this.intervalId);
              }
            });
        }, 5000);
      }
    }
  },
  mounted() {
    this.status();
  }
};
</script>

